import React from 'react';

interface ClayMarkProps {
  size?: number;
  className?: string;
  monochrome?: boolean;
  broken?: boolean;
  title?: string;
}

export const ClayMark: React.FC<ClayMarkProps> = ({
  size = 32,
  className = '',
  monochrome = false,
  broken = false,
  title,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    className={className}
    role={title ? 'img' : undefined}
    aria-hidden={title ? undefined : true}
  >
    {title && <title>{title}</title>}
    {monochrome ? (
      <g transform="rotate(-14 24 24)" fill="none" stroke="currentColor">
        <ellipse cx="24" cy="24" rx="20" ry="11.6" strokeWidth="2.6" />
        <ellipse cx="24" cy="24" rx="12.4" ry="7" strokeWidth="2.2" />
        <ellipse cx="24" cy="24" rx="5.4" ry="2.9" fill="currentColor" stroke="none" />
        <path d="M24 35.6a20 11.6 0 0 0 17.8-8" strokeWidth="2.6" strokeLinecap="round" />
      </g>
    ) : (
      <g transform="rotate(-14 24 24)">
        <ellipse cx="24" cy="27.6" rx="20" ry="11.6" fill="#B8391A" />
        <ellipse cx="24" cy="24" rx="20" ry="11.6" fill="#F05A28" />
        {!broken && (
          <ellipse cx="24" cy="24" rx="13" ry="7.3" fill="none" stroke="#C6461C" strokeWidth="2.2" />
        )}
        <ellipse cx="24" cy="24" rx="6" ry="3.2" fill="#C6461C" />
        {broken ? (
          <path
            d="M24 24 5 17M24 24l17-9M24 24l-4 11.4M24 24l15 8"
            stroke="#F7F8F8"
            strokeWidth="2.6"
            strokeLinecap="round"
          />
        ) : (
          <path
            d="M6.2 20.4A20 11.6 0 0 1 24 12.4"
            fill="none"
            stroke="#FFC0A4"
            strokeWidth="2.4"
            strokeLinecap="round"
          />
        )}
      </g>
    )}
  </svg>
);

interface DeadBirdLogoProps {
  markSize?: number;
  className?: string;
  inverse?: boolean;
  compact?: boolean;
}

export const DeadBirdLogo: React.FC<DeadBirdLogoProps> = ({
  markSize = 30,
  className = '',
  inverse = false,
  compact = false,
}) => (
  <div className={`inline-flex min-w-0 items-center gap-2 ${className}`} aria-label="DeadBird">
    <ClayMark size={markSize} className="flex-none" />
    {!compact && (
      <span
        className={`font-data text-[1.45rem] font-bold leading-none ${inverse ? 'text-white' : 'text-ink'}`}
      >
        DeadBird
      </span>
    )}
  </div>
);
